import { ArrowRight, ArrowUpRight, Building2, BedDouble, Sparkles, Stethoscope } from "lucide-react";

const solutions = [
  {
    icon: BedDouble,
    kicker: "Demo",
    title: "Unități de cazare",
    text: "Prezentare modernă, cereri directe, notificări rapide și opțiune de administrare mai clară pentru businessurile care vor mai mult control asupra rezervărilor.",
    cta: "Vezi pagina pentru unități de cazare",
    href: "/unitati-de-cazare",
    external: false,
  },
  // {
  //   icon: Stethoscope,
  //   kicker: "Demo",
  //   title: "Clinici și servicii medicale",
  //   text: "O structură clară pentru servicii, medici și programări, gândită să inspire încredere și să transforme mai ușor vizitatorii în cereri directe.",
  //   cta: "Vezi demo-ul pentru clinică",
  //   href: "https://demo-clinica.rezervix.ro",
  //   external: true,
  // },
  {
    icon: Sparkles,
    kicker: "Custom",
    title: "Businessuri bazate pe programări",
    text: "Pentru beauty, wellness și alte servicii locale care au nevoie de vizibilitate mai bună și de un mod simplu prin care clientul să poată face o solicitare.",
    cta: "Solicită o variantă pentru businessul tău",
    href: "#lead-form",
    external: false,
  },
];

export default function SolutionsSection() {
  return (
    <section className="rz-section rz-section--light" id="industrii">
      <div className="rz-shell">
        <div className="rz-section-heading rz-section-heading--split">
          <div>
            <p className="rz-kicker rz-kicker--dark">Soluții pe industrii</p>
            <h2>Rezervix se adaptează în funcție de tipul de business și de modul în care primești cererile.</h2>
          </div>
          <p>
            Pornim de la aceeași bază: o prezentare bună, formulare directe, notificări rapide și, dacă ai nevoie, un sistem mai clar de administrare.
          </p>
        </div>

        <div className="rz-solution-grid">
          {solutions.map((item) => {
            const Icon = item.icon;
            const LinkTag = "a";

            return (
              <article key={item.title} className="rz-solution-card">
                <div className="rz-solution-card__top">
                  <div className="rz-solution-card__icon">
                    <Icon size={22} />
                  </div>
                  <span>{item.kicker}</span>
                </div>

                <div className="rz-solution-card__body">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>

                <LinkTag
                  href={item.href}
                  {...(item.external ? { target: "_blank", rel: "noreferrer" } : {})}
                  className="rz-solution-card__link"
                >
                  {item.cta}
                  {item.external ? <ArrowUpRight size={16} /> : <ArrowRight size={16} />}
                </LinkTag>
              </article>
            );
          })}
        </div>

        <div className="rz-solution-note">
          <Building2 size={18} />
          <p>
            Ai alt tip de business? Putem construi o variantă adaptată, păstrând aceeași direcție: claritate, experiență bună pentru client și un flux mai simplu pentru tine.
          </p>
        </div>
      </div>
    </section>
  );
}
